import axios from 'axios';


const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL || ''
})


axiosInstance.interceptors.response.use(
    response=>{
        return response
    },
    error=>{
        if (error.response && error.response.status === 401) {
            // Only clear and redirect if we're not already on a public page
            // AND if this is not a login/register request (those should show errors, not redirect)
            const currentPath = window.location.pathname;
            const isLoginRequest = error.config?.url?.includes('/login.php') || error.config?.url?.includes('/register.php');
            const publicPaths = ['/login', '/register', '/forgot-password', '/', '/log'];
            const isPublicPath = publicPaths.some(path => currentPath === path || currentPath.startsWith(path + '/'));
            
            // Check if this is a "user not found" or "player not created" error (for new users)
            const errorMessage = error.response?.data?.message || error.response?.data?.error || '';
            const isNewUserError = errorMessage.includes('User not found') || 
                                   errorMessage.includes('player not found') ||
                                   errorMessage.includes('No player found') ||
                                   errorMessage.includes('User doesn\'t have a player') ||
                                   errorMessage.includes('Player not created yet') ||
                                   errorMessage.includes('Authorization token missing');
            
            // Check if user has a token (they're logged in but might not have created player yet)
            const hasToken = !!(localStorage.getItem('token') || localStorage.getItem('session_token'));
            
            // Don't redirect if:
            // 1. We're already on a public page (login, register, etc.)
            // 2. This is a login/register request (let the component handle the error)
            // 3. This is a new user error AND user has a token (they're logged in but haven't created player)
            // 4. This is "Authorization token missing" error (might be a temporary issue)
            if (!isPublicPath && !isLoginRequest && !(isNewUserError && hasToken)) {
                // Only clear localStorage if it's a real authentication error
                const token = localStorage.getItem('token') || localStorage.getItem('session_token');
                if (!token) {
                    // No token at all, clear everything
                    localStorage.clear();
                } else {
                    // Token exists but got 401 - might be expired or invalid
                    // Only clear auth-related items, not everything
                    localStorage.removeItem('token');
                    localStorage.removeItem('session_token');
                    localStorage.removeItem('userData');
                }
                const basePath = process.env.REACT_APP_BASE_PATH || '/';
                window.location.href = basePath + '/login';
            }
        }
        // Return a rejected promise for other errors
        return Promise.reject(error);
    }
)

axiosInstance.interceptors.request.use(
    (config)=>{
        // Try to get session_token first (for chat moderation and new APIs)
        let token = localStorage.getItem('session_token');
        
        // Fallback to token if session_token doesn't exist
        if (!token) {
            token = localStorage.getItem('token');
        }
        
        // If no token, try to get session from userData
        if (!token) {
            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    // Check if there's a session field in userData
                    if (user.session) {
                        token = user.session;
                    }
                } catch (e) {
                    // Ignore parse errors
                }
            }
        }
        
        // If still no token, try to get from rekeningen session via cookie/header
        // For now, we'll use credentials: 'include' to send cookies
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Always include credentials for cookie-based sessions
        config.withCredentials = true;
        
        return config;
    },
    (error) => {
        return Promise.reject(error);   
    }
)

export default axiosInstance;
